import { render, staticRenderFns } from "./Sequence.vue?vue&type=template&id=6076b474&scoped=true&"
import script from "./Sequence.vue?vue&type=script&lang=ts&"
export * from "./Sequence.vue?vue&type=script&lang=ts&"
import style0 from "./Sequence.vue?vue&type=style&index=0&id=6076b474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6076b474",
  null
  
)

export default component.exports